@switch (dialogData.modalType) {
  @case (ModalType.InputModal) {
    <h2 mat-dialog-title class="create-dialog-title">{{ dialogData.title }}</h2>
    <mat-dialog-content class="top-margin bottom-margin">
      <input aria-label="Name" autocomplete="off" class="custom-dialog-input" data-qa="text-name-input" id="name-input" tabindex="0"
             matInput placeholder="{{ dialogData.placeholder }}" [class.error]="showError()" [(ngModel)]="name"
             (input)="onResetInput()" (keyup.enter)="onSaveDialog()" required>
      @if (showError()) {
        <mat-error>{{ inputError() }}</mat-error>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="close-button secondary_materials_button xsmall_button" data-qa="close-button" disableRipple="true" tabindex="0"
              mat-stroked-button (click)="onCloseDialog()">
        {{ dialogData.closeButtonText }}
      </button>
      <button class="primary_materials_button xsmall_button" data-qa="confirm-button" disableRipple="true" tabindex="0"
              id="confirm-button" mat-stroked-button [disabled]="!name || showError()" (click)="onSaveDialog()">
        {{ dialogData.confirmButtonText }}
      </button>
    </mat-dialog-actions>
  }
  @case (ModalType.YesNoModal) {
    <mat-dialog-content class="top-margin">
      <h2 mat-dialog-title>{{ dialogData.title }}</h2>
      <mat-dialog-actions>
        @if (dialogData.cancelButtonText) {
          <button class="secondary_materials_button xsmall_button" data-qa="cancel-button" disableRipple="true" tabindex="0"
                  mat-stroked-button (click)="onCancelDialog()">
            {{ dialogData.cancelButtonText }}
          </button>
        }
        <button class="close-button secondary_materials_button xsmall_button" data-qa="close-button" disableRipple="true" tabindex="0"
                mat-stroked-button (click)="onCloseDialog()">
          {{ dialogData.closeButtonText }}
        </button>
        <button class="primary_materials_button xsmall_button confirm-button" data-qa="confirm-button" disableRipple="true" tabindex="0"
                mat-stroked-button (click)="onConfirmDialog()">
          {{ dialogData.confirmButtonText }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case (ModalType.ContinueCancelModal) {
    <mat-dialog-content class="top-margin">
      <h2 mat-dialog-title>{{ dialogData.title }}</h2>
      <mat-dialog-actions>
        <button class="close-button secondary_materials_button xsmall_button" data-qa="close-button" disableRipple="true" tabindex="0"
                mat-stroked-button (click)="onCancelDialog()">
          {{ dialogData.closeButtonText }}
        </button>
        <button class="primary_materials_button xsmall_button" data-qa="confirm-button" disableRipple="true" tabindex="0"
                mat-stroked-button (click)="onContinueDialog()">
          {{ dialogData.confirmButtonText }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case (ModalType.PreviewModal) {
    <mat-dialog-content class="top-margin">
      <div class="preview-modal-wrapper">
        <button class="bg-white-button mat-icon-button" data-qa="preview-dialog-close-button"
                disableRipple="true" mat-button (click)="onCloseDialog()">
          <i class="fa-solid fa-x font-bold"></i>
        </button>
      </div>
      <div class="image-wrapper">
          <img height="400" priority width="400" [src]="'../assets/images/'+dialogData.previewImage+'.png'" [alt]="" />
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="bottom-component">
        <p>{{dialogData.previewMessage}}</p>
        <button class="primary_materials_button xlarge_button top-margin" disableRipple="true" tabindex="0"
                mat-stroked-button data-qa="add-preview-component-button"
                (click)="onConfirmDialog()">
          Add
        </button>
      </div>
    </mat-dialog-actions>
  }
  @case (ModalType.ConfirmModal) {
    <mat-dialog-content class="confirm-modal">
      <button type="button" class="close mat-icon-button" data-qa="confirm-modal-x-close-button"
              disableRipple="true" mat-button aria-label="Close" (click)="onCloseDialog()">
        <i class="fa-solid fa-x font-bold"></i>
      </button>
      <div class="confirm-modal-content">
        @if (dialogData.checkMark) {
          <i class="fa-regular fa-circle-check large-circle-check top-margin"></i>
        }
        @if (dialogData.warning) {
          <lib-svg-icon [svgName]="warningIcon" svgWidth="33px" svgHeight="33px"></lib-svg-icon>
        }
        <h2 class="confirm-dialog-title" mat-dialog-title>{{ dialogData.title }}</h2>
        <p class="confirm-dialog-subtitle">{{dialogData.subtitle}}</p>
        <p class="confirm-dialog-message" [class]="dialogData.align">{{dialogData.message}}</p>
        <mat-dialog-actions class="confirm-modal-actions">
          <button class="close-button secondary_materials_button xsmall_button" data-qa="close-button" disableRipple="true" tabindex="0"
                  id="confirm-modal-close-button" mat-stroked-button (click)="onCloseDialog()">
            {{ dialogData.closeButtonText }}
          </button>
          <button class="confirm-modal-button primary_materials_button xsmall_button" data-qa="confirm-button" disableRipple="true" tabindex="0"
                  id="confirm-modal-confirm-button" mat-stroked-button (click)="onConfirmDialog()">
            {{ dialogData.confirmButtonText }}
          </button>
        </mat-dialog-actions>
      </div>
    </mat-dialog-content>
  }
  @case (ModalType.CustomModal) {
     <ng-container *ngComponentOutlet="dialogData.component"></ng-container>
  }
  @default {
     <div>Default Modal</div>
  }
}